import { __decorate, __metadata } from "tslib";
import { IsUndefinable, IsUUIDWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsNotEmpty, IsString } from 'class-validator';
import { PromotionUsageExposeGroup } from '../interface';
export class UsedPromotionDto {
}
__decorate([
    Expose({ groups: [PromotionUsageExposeGroup.READ, PromotionUsageExposeGroup.CREATE] }),
    IsNotEmpty({ always: true }),
    IsUUIDWithLVS('4', { always: true }),
    ApiProperty({ type: () => String, readOnly: true, format: 'uuid', description: 'uuid v4', example: 'e12acc6f-2f34-442c-92d3-d4199fb12345' }),
    __metadata("design:type", String)
], UsedPromotionDto.prototype, "uuid", void 0);
__decorate([
    Expose({ groups: [PromotionUsageExposeGroup.READ, PromotionUsageExposeGroup.CREATE] }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    ApiPropertyOptional({ type: () => String, description: 'promoCode text', example: 'TEST10VIP' }),
    __metadata("design:type", String)
], UsedPromotionDto.prototype, "promoCode", void 0);
__decorate([
    Expose({ groups: [PromotionUsageExposeGroup.READ, PromotionUsageExposeGroup.CREATE] }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    ApiPropertyOptional({ type: () => String, description: 'Promo Code Id', format: 'uuid' }),
    __metadata("design:type", String)
], UsedPromotionDto.prototype, "promoCodeUuid", void 0);
__decorate([
    Expose({ groups: [PromotionUsageExposeGroup.READ, PromotionUsageExposeGroup.CREATE] }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    ApiPropertyOptional({ type: () => Boolean }),
    __metadata("design:type", Boolean)
], UsedPromotionDto.prototype, "isTemplate", void 0);
//# sourceMappingURL=UsedPromotionDto.js.map